import { Kicker, Reveal } from "@/components/Motion";

export default function LegalLayout({ kicker, title, updated, sections, testId }) {
  return (
    <div className="mx-auto max-w-4xl px-4 pb-24 pt-28 sm:px-6 lg:px-8" data-testid={testId}>
      <Reveal>
        <Kicker>{kicker}</Kicker>
        <h1 className="mt-4 font-display text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">
          {title}
        </h1>
        <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.15em] text-slate-500">
          Last updated — {updated}
        </p>
      </Reveal>
      <div className="mt-12 space-y-6">
        {sections.map((s, i) => (
          <Reveal key={s.heading} delay={i * 0.03}>
            <section className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
              <div className="flex items-start gap-4">
                <span className="font-mono text-sm font-semibold text-blue-900">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <h2 className="font-display text-xl font-semibold tracking-tight text-slate-900">
                    {s.heading}
                  </h2>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600 sm:text-base">
                    {s.body}
                  </p>
                </div>
              </div>
            </section>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
